import { apiCall } from "./apiService";
import { clearAdminSession } from "../auth/session";

/** Admin APIs always send adminToken */
export const adminApi = (opts) => apiCall({ ...opts, role: "admin" });

export const handleAdminLogoutIfNeeded = (data) => {
  if (data?.logout) {
    clearAdminSession();
    window.location.href = "/admin/login";
    return true;
  }
  return false;
};
